import { useState } from "react";
import { api, formatApiError } from "@/lib/api";
import { toast } from "sonner";
import { HeartHandshake } from "lucide-react";

export function PartnerNudge({ token, options, initial }) {
  const [sent, setSent] = useState(initial || null);
  const [busy, setBusy] = useState(false);

  const send = async (key) => {
    setBusy(true);
    try {
      const { data } = await api.post(`/share/public/${token}/nudge`, { choice: key });
      setSent(data.choice);
      toast.success("Sent. She'll see it next time she opens Meridia.");
    } catch (e) {
      toast.error(formatApiError(e.response?.data?.detail));
    } finally {
      setBusy(false);
    }
  };

  const sentText = options.find((o) => o.key === sent)?.text;

  return (
    <div className="mt-6 card-paper p-6 sm:p-8 bg-[#F4EDE2]/60" data-testid="partner-nudge">
      <div className="flex items-center gap-2 text-[#5F7463]">
        <HeartHandshake size={18} />
        <p className="text-xs uppercase tracking-[0.18em] font-semibold">Let her know you looked</p>
      </div>
      {sent ? (
        <p className="mt-3 font-serif-display text-xl text-[#2C221E] leading-snug" data-testid="partner-nudge-sent">
          You said: “{sentText}” — she'll see it this week.
        </p>
      ) : (
        <>
          <p className="mt-3 text-[#52443E]">One tap, once a week. No reply needed from her.</p>
          <div className="mt-4 flex flex-wrap gap-2">
            {options.map((o) => (
              <button
                key={o.key}
                type="button"
                className="chip"
                disabled={busy}
                onClick={() => send(o.key)}
                data-testid={`partner-nudge-${o.key}`}
              >
                {o.text}
              </button>
            ))}
          </div>
        </>
      )}
    </div>
  );
}
